import React, { Component } from 'react'
import Drawer from 'material-ui/Drawer'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'
import IconSignIn from 'material-ui/svg-icons/action/assignment-ind'
import IconDelete from 'material-ui/svg-icons/action/delete'
import IconHome from 'material-ui/svg-icons/action/home'
import IconPeople from 'material-ui/svg-icons/social/people'
import ListItem from 'material-ui/List/ListItem'
import IconTaxi from 'material-ui/svg-icons/maps/local-taxi'
import IconSettings from 'material-ui/svg-icons/action/settings'
import IconAnnouncement from 'material-ui/svg-icons/action/speaker-notes'
import IconBooking from 'material-ui/svg-icons/communication/contact-phone'
import { siteMap } from '../../resources/siteMap'

import { cyan100, cyan300, grey900 } from 'material-ui/styles/colors'
import Avatar from 'material-ui/Avatar'

const Styles = {
  textStyle: {
    marginLeft: 0,
    marginTop: 5,
    marginBottom: 5,
    verticalAlign: 'middle'
  },
  iconStyles: {
    marginRight: 24,
    verticalAlign: 'middle'
  },
  topMenu: {
    backgroundColor: cyan100,
    fontWeight: 'bold'
  }
}

const avatar = (icon, bgcolor, frontColor) => {
  return <Avatar icon={icon} style={Styles.iconStyles} size={36} color={frontColor || grey900} backgroundColor={bgcolor || orange200} />
}

const LeftNav = ({ loggedIn, role, drawerOpen, selectMenu, onRequestChange }) => (
  <Drawer docked={false} open={drawerOpen} onRequestChange={onRequestChange} style={{ overflowX: 'hidden' }}>
    <ListItem style={Styles.topMenu}>ACE</ListItem>
    {
        siteMap.map((p) => 
        <MenuItem
          key={p.title}
          onTouchTap={() => selectMenu(p.path)}
          style={Styles.textStyle}
          insetChildren={false}
        >
          {avatar(p.icon, cyan300)}{p.title}
        </MenuItem>)
      }
  </Drawer>
)

export default LeftNav



// WEBPACK FOOTER //
// ./src/layouts/LeftNav/LeftNav.js